export enum TipoExibicaoClienteMapaModel {
  TODOS = 'TODOS',
  EM_PRE_CARGA = 'EM_PRE_CARGA',
  SEM_PRE_CARGA = 'SEM_PRE_CARGA',
  ROTEIRIZADOS = 'ROTEIRIZADOS',
  NAO_ROTEIRIZADOS = 'NAO_ROTEIRIZADOS'
}
